import { Injectable } from "@angular/core";
import { Claims } from "../../../../src/app/_models/common/claims";
import { BehaviorSubject } from "rxjs";
import { FunctionPackageEnum, Page } from "src/app/_models";
import { DragnDropCardImportResponse } from "src/app/_models/common/card-review-response";

@Injectable({
  providedIn: "root",
})
export class ClaimsService {
  isCreditCardScanInProgress: boolean = false;
  private _isCreditCardScanInProgress = new BehaviorSubject(
    this.isCreditCardScanInProgress
  );
  currentIsCreditCardScanInProgress =
    this._isCreditCardScanInProgress.asObservable();

  updateIsCreditCardScanInProgress(newValue: boolean) {
    this._isCreditCardScanInProgress.next(newValue);
  }

  isScanModalDismissed: boolean = false;
  private _isScanModalDismissed = new BehaviorSubject(this.isScanModalDismissed);
  currentIsScanModalDismissed = this._isScanModalDismissed.asObservable();

  updateIsScanModalDismissed(newValue: boolean) {
    this.isScanModalDismissed = newValue;
    this._isScanModalDismissed.next(newValue);
  }

  isImportSubmitting: boolean = false;
  private _isImportSubmitting = new BehaviorSubject(this.isImportSubmitting);
  currentIsImportSubmitting = this._isImportSubmitting.asObservable();

  updateIsImportSubmitting(newValue: boolean) {
    this.isImportSubmitting = newValue;
    this._isImportSubmitting.next(newValue);
  }

  isImportModalDismissed: boolean = false;
  private _isImportModalDismissed = new BehaviorSubject(this.isImportModalDismissed);
  currentIsImportModalDismissed = this._isImportModalDismissed.asObservable();

  updateIsImportModalDismissed(newValue: boolean) {
    this.isImportModalDismissed = newValue;
    this._isImportModalDismissed.next(newValue);
  }

  importingTransactionCount: number = 0;
  private _importingTransactionCount = new BehaviorSubject(this.importingTransactionCount);
  currentImportingTransactionCount = this._importingTransactionCount.asObservable();

  updateImportingTransactionCount(newValue: number) {
    this.importingTransactionCount = newValue;
    this._importingTransactionCount.next(newValue);
  }

  isAssigningPhase: boolean = false;
  private _isAssigningPhase = new BehaviorSubject(this.isAssigningPhase);
  currentIsAssigningPhase = this._isAssigningPhase.asObservable();

  updateIsAssigningPhase(newValue: boolean) {
    this.isAssigningPhase = newValue;
    this._isAssigningPhase.next(newValue);
  }

  importProgress: number = 0;
  private _importProgress = new BehaviorSubject(this.importProgress);
  currentImportProgress = this._importProgress.asObservable();

  updateImportProgress(newValue: number) {
    this.importProgress = newValue;
    this._importProgress.next(newValue);
  }

  isCreditCardImportInProgress: boolean = false;
  private _isCreditCardImportInProgress = new BehaviorSubject(
    this.isCreditCardImportInProgress
  );
  currentIsCreditCardImportInProgress =
    this._isCreditCardImportInProgress.asObservable();

  updateIsCreditCardImportInProgress(newValue: boolean) {
    this._isCreditCardImportInProgress.next(newValue);
  }

  isAwaitingAmountDirectionConfirmation: boolean = false;
  private _isAwaitingAmountDirectionConfirmation = new BehaviorSubject(
    this.isAwaitingAmountDirectionConfirmation
  );
  currentIsAwaitingAmountDirectionConfirmation =
    this._isAwaitingAmountDirectionConfirmation.asObservable();

  updateIsAwaitingAmountDirectionConfirmation(newValue: boolean) {
    this._isAwaitingAmountDirectionConfirmation.next(newValue);
  }

  dragnDropCardImportResponse: DragnDropCardImportResponse = null;
  private _dragnDropCardImportResponse = new BehaviorSubject(
    this.dragnDropCardImportResponse
  );
  currentdragnDropCardImportResponse =
    this._dragnDropCardImportResponse.asObservable();

  updateDragnDropCardImportResponse(newValue: DragnDropCardImportResponse) {
    this._dragnDropCardImportResponse.next(newValue);
  }

  claims: Claims = null;
  private _claims = new BehaviorSubject(this.claims);
  currentClaims = this._claims.asObservable();

  constructor() {}
  updateClaims(newClaims: Claims) {
    this._claims.next(newClaims);

    if (newClaims) {
      localStorage.setItem("claims", JSON.stringify(newClaims));
    } else {
      localStorage.removeItem("claims");
    }
  }

  public selectedPackageCategory: number = 1;
  private _selectedPackageCategory = new BehaviorSubject(
    this.selectedPackageCategory
  );
  currentSelectedPackageCategory = this._selectedPackageCategory.asObservable();

  updateSelectedPackageCategory(newValue: number) {
    this._selectedPackageCategory.next(newValue);
  }

  SetFunctionPackageClaims(
    functionPurchasedTrailList: any,
    existingClaims: Claims,
    functionCalledFrom: number
  ) {
    for (let index = 0; index < functionPurchasedTrailList.length; index++) {
      let element = functionPurchasedTrailList[index];

      let functionId = 0;
      switch (functionCalledFrom) {
        case Page.Home:
          functionId = element.functionId;
          break;
        case Page.ShoppingCartConfirm:
          functionId = element.functionPackageId;
          break;
      }

      existingClaims = this.SetValueToFunctionPackageClaims(
        functionId,
        true,
        existingClaims
      );
    }

    return existingClaims;
  }

  SetValueToFunctionPackageClaims(
    functionId: number,
    value: boolean,
    existingClaims: Claims
  ) {
    switch (functionId) {
      case FunctionPackageEnum.AccountingIntegration:
        existingClaims.IsAccountingIntegrationPackagePurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.SetupCreditCard:
        existingClaims.IsCreditCardPackageSubscribed = value;
        break;
      case FunctionPackageEnum.ExpenseCategoryManagement:
        existingClaims.IsExpenseCategoryPackagePurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.SetupCostCentre_Assign_toClaimants:
        existingClaims.IsCostCentrePackagePurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.Customer:
        existingClaims.IsCustomerPackagePurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.ExportReport:
        existingClaims.IsExportReportPackagePurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.SetupTaxRate:
        existingClaims.IsTaxPackagePurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.ProjectBudget:
        existingClaims.IsProjectBudgetPurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.SetupMultipleCompanies:
        existingClaims.IsMultipleCompaniesPackagePurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.NonReimbursableFuel:
        existingClaims.isNRPackagePurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.FuelCard:
        existingClaims.isFCPackagePurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.Location:
        existingClaims.IsLocationPurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.ConfigureAdministratorPrivilege:
        existingClaims.IsSecondaryFMPackagePurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.AssignDeputyToApprovers:
        existingClaims.IsAssignDeputyToApproversPurchased = value;
        break;
      case FunctionPackageEnum.Supplier:
        existingClaims.IsSupplierPurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.DutyofCare:
        existingClaims.IsDocPackagePurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.MultipleCountry:
        existingClaims.IsMultipleCountryPackagePurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.DuplicateChecker:
        existingClaims.IsDuplicateCheckerPurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.Delegate:
        existingClaims.IsDelegateFunctionPurchasedOrTrial = value;
        if (!value) {
          existingClaims.IsDelegator = false;
          existingClaims.IsDelegate = false;
        }
        break;
      case FunctionPackageEnum.AttendeeType:
        existingClaims.IsAttendeeTypePurchased = value;
        break;
      case FunctionPackageEnum.APAutomation:
        existingClaims.isAPAutomationFunctionPurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.RecallExportedExpenses:
        existingClaims.IsRecallExportedExpensesPurchased = value;
        break;
      case FunctionPackageEnum.SpecialCategory:
        existingClaims.IsSpecialCategoryFunctionPurchasedorTrial = value;
        break;
      case FunctionPackageEnum.Container:
        existingClaims.IsContainerPurchasedOrTrial = value;
        break;
      case FunctionPackageEnum.Pre_Approvals:
        existingClaims.isPreApprovalPurchased = value;
        break;
    }

    return existingClaims;
  }

  onToggleMobileMenu(IsLeftMenuCollapseAndStopToggle: boolean) {
    if (!IsLeftMenuCollapseAndStopToggle) {
      document.body.classList.toggle("sidebar-enable");
      const currentSIdebarSize =
        document.body.getAttribute("data-sidebar-size");
      if (window.screen.width >= 992) {
        if (currentSIdebarSize == null) {
          document.body.getAttribute("data-sidebar-size") == null ||
          document.body.getAttribute("data-sidebar-size") == "lg"
            ? document.body.setAttribute("data-sidebar-size", "sm")
            : document.body.setAttribute("data-sidebar-size", "lg");
        } else if (currentSIdebarSize == "md") {
          document.body.getAttribute("data-sidebar-size") == "md"
            ? document.body.setAttribute("data-sidebar-size", "sm")
            : document.body.setAttribute("data-sidebar-size", "md");
        } else {
          document.body.getAttribute("data-sidebar-size") == "sm"
            ? document.body.setAttribute("data-sidebar-size", "lg")
            : document.body.setAttribute("data-sidebar-size", "sm");
        }
      }
    } else {
      document.body.setAttribute("data-sidebar-size", "sm");
    }
  }
}
